import axios from 'axios'
import { Weather } from '../types/Stopover'

async function fetchStopWeather(id: string) {
  if (process.env.REACT_APP_WEATHER_URL) {
    const { data } = await axios.get(`${process.env.REACT_APP_WEATHER_URL}?escale=${id}`)
    return data as Weather
  }
  return null
}

export default fetchStopWeather
